import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveCr3Failure, saveCr3Success, updateCr3Failure, updateCr3Success } from './actions';

export function* saveCr3({ payload }) {
  try {
    yield call(api.post, 'api/cr3', payload.data, { withCredentials: true });

    yield put(saveCr3Success());

    toast.success('CR3 criado com sucesso!')

    history.push('/specifications/pilar3/resources/cr3');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveCr3Failure());
  }
}

export function* updateCr3({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/cr3/${id}`, payload.data, { withCredentials: true });

    yield put(updateCr3Success());

    toast.success('CR3 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/cr3');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateCr3Failure());
  }
}

export default all([
  takeLatest('@cr3/SAVE_REQUEST', saveCr3),
  takeLatest('@cr3/UPDATE_REQUEST', updateCr3)
]);